import React from "react";
import background from '../images/hero1.jpg'


const Header = () => (
  <div className="header" style={{ 
    backgroundImage: `url(${background})`}} >
    
    <h1 className="header-title">Jili Jiang</h1>
    
  </div>
);

export default Header;